module.exports = __webpack_public_path__ + "img/expostyle_0924_turquoise.a5eea545.jpg";